import React from "react";
import classnames from "classnames";
import {
  Checkpoint,
  CheckpointRating,
} from "../../../lib/ground-aws-graphql-core/models/Api/Inspection";
import { getTranslation } from "../../../utils/translation";
import classNames from "classnames";

interface Props {
  ratings: CheckpointRating[];
  checkpoint: Checkpoint;
}

const CheckpointComponentRating = (props: Props): JSX.Element => {
  const className = classnames(
    "mt-2 sm:mt-0 sm:col-span-1 rounded-10 border h-full opacity-1 bg-white border-ground-gray-200"
  );

  const { checkpoint, ratings } = props;

  const rating = ratings?.find(r => r.checkpoint.id === checkpoint.id);

  const classNameEnabled = () =>
    classNames(
      "absolute top-0 right-0 block h-2 w-2 rounded-full text-white shadow-solid",
      {
        "bg-red-400": !checkpoint.enabled,
        "bg-green-400": checkpoint.enabled,
      }
    );

  return (
    <div className={className} key={checkpoint.id}>
      <div className="relative flex px-2 py-2 justify-between">
        <div className="flex flex-col ml-2 justify-around">
          <span className="inline-block relative text-14px text-ground-gray-100">
            <span className="mr-3">{getTranslation(checkpoint.title)}</span>
            <span className={classNameEnabled()} />
          </span>
        </div>
      </div>
    </div>
  );
};

export default CheckpointComponentRating;
